import { useLocation, useParams } from '@tanstack/react-router';
import { FileRoutesByTo } from '@uturn/portal/routeTree.gen';
import { ParentLocation } from '@uturn/portal/types/shipments';

export function useParentLocation(): ParentLocation {
	const params = useParams({ strict: false });
	const location = useLocation();

	return {
		href: location.pathname as keyof FileRoutesByTo,
		search: location.search,
		params,
	};
}
